export class NotificationPolicyConfigSplunk {
    'token';
    'url';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        },
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigSplunk.attributeTypeMap;
    }
    constructor() {
    }
}
